import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from 'components/form/TextInput';

const Address = ({ question }) => {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <TextField fullWidth placeholder="Address Line 1" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <TextField fullWidth placeholder="City" />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField fullWidth placeholder="State" />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField placeholder="Postal Code" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Address;
